namespace SP {
    export interface ShippingMethodParameter {
        name: string;
        value: string;
        key: string;
        addonDependency: string;
        visible: boolean;
        include: boolean;
        type: string;
        scope: string;
        options: ShippingMethodParameterOption[];

    }
}